<template>
  <div class="business-area-list-page">
    <div class="head-wrap flex-rowl">
      <div class="icon">
        <img src="../../assets/images/business-title-icon.png" alt="" />
      </div>
      <div class="head-content">
        <h1>用户数据</h1>
        <p>小铃铛注册用户数据</p>
      </div>
    </div>

    <div class="main-wrap">
      <h1>当前用户注册数量：</h1>
      <h2>(注意：仅统计正式授权的用户数量)</h2>
      <p>{{totalPage}}</p>
    </div>
  </div>
</template>
  
  <script>
import { getUserList } from "../../api/public";
export default {
  name: "userDate",
  data() {
    return {
      params: {
        Page: 1,
        PageSize: 30,
        keyword: "",
      },
      dataList: [], //
      totalPage: 1, // 总页数
      isLoading: true, // 是否正在加载
      hasMore: false, // 是否还有更多数据
      isLoadingMore: false, // 新增加载状态锁
    };
  },
  async mounted() {
    this.getUserList();
  },
  methods: {
    // 获取街道列表
    async getUserList() {
      try {
        const res = await getUserList(this.params);
        if (res.list) {
          this.dataList = this.dataList.concat(res.list);
          this.totalPage = res.total;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },
  },
};
</script>
  
  <style scoped lang="less">
.business-area-list-page {
  box-sizing: border-box;
  .head-wrap {
    margin: auto;
    padding: 60px 0 150px 80px;
    box-sizing: border-box;
    font-size: 20px;
    color: #333333;
    .icon {
      width: 33px;
      height: 40px;
      margin-right: 24px;
    }
    h1 {
      font-size: 30px;
      margin-bottom: 7px;
    }
  }
  .main-wrap {
    color: #000000;
    padding-left: 80px;
    box-sizing: border-box;
    h1 {
      font-size: 36px;
      margin-bottom: 20px;
    }
    h2 {
      font-size: 30px;
      color: red;
      margin-bottom: 40px;
    }
    p {
      font-size: 60px;
    }
  }
}
</style>